(function () {
    'use strict';

    angular.module("imApp").factory("poJobsService", ['$ihttp', function ($ihttp) {
        var service = {
            getPoJobs: function (parms) {
                return $ihttp.post({
                    method: 2595,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();